import React from "react";
import {
  formatCurrency,
  normalizeName,
  toDisplayDate,
} from "../../utils/dashboardUtils";

const TablesSection = ({
  filteredVisits,
  customerVisitSearch,
  setCustomerVisitSearch,
  filteredCustomerVisitRows,
}) => {
  return (
    <>
      <div className="dashboard-table-wrap">
        <div className="dashboard-table-title">
          Customer Visit Frequency (Selected Range)
        </div>
        <div className="p-3 pb-0">
          <input
            type="text"
            className="form-control"
            placeholder="Search by mobile number or patient name"
            value={customerVisitSearch}
            onChange={(e) => setCustomerVisitSearch(e.target.value)}
          />
        </div>
        <table className="table dashboard-table align-middle">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Mobile</th>
              <th>Visits in Selected Range</th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomerVisitRows.length > 0 ? (
              filteredCustomerVisitRows.map((row) => (
                <tr key={row.key}>
                  <td>{row.patientName}</td>
                  <td>{row.mobileNumber}</td>
                  <td>{row.visits}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4 text-secondary">
                  No customer records match your search
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="dashboard-table-wrap">
        <div className="dashboard-table-title">Recent Visits</div>
        <table className="table dashboard-table align-middle">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Date</th>
              <th>Doctor</th>
              <th>Service</th>
              <th>Paid</th>
              <th>Status</th>
              <th>Feedback</th>
            </tr>
          </thead>
          <tbody>
            {filteredVisits.slice(0, 12).length > 0 ? (
              filteredVisits.slice(0, 12).map((visit) => (
                <tr key={visit.BookingConsultationId}>
                  <td>{normalizeName(visit.Name, "-")}</td>
                  <td>{toDisplayDate(visit.AppointmentDate || visit.BookingDate)}</td>
                  <td>{normalizeName(visit.DoctorName, "-")}</td>
                  <td>{normalizeName(visit.ServiceName || visit.Appointment, "-")}</td>
                  <td>{formatCurrency(visit.PaidAmount)}</td>
                  <td>{visit.Status || "-"}</td>
                  <td>{normalizeName(visit.CustomerFeedBack, "-")}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-secondary">
                  No recent visits in this range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TablesSection;
